import cn from 'classnames';
import styles from './label.module.scss';

interface IProps {
  formatLabel?: (value?: number, type?: string) => string,
  type: string,
  children: number,
}
function Label(props: IProps) {
  const labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;
  const labelCls = cn(styles.label, {
    [styles.labelMax]: props.type === 'max',
    [styles.labelMin]: props.type === 'min',
    [styles.labelValue]: props.type === 'value',
  });
  const containerCls = cn(styles.labelContainer, {
    [styles.isLabelMax]: props.type === 'max',
  });
  return (
    <span className={ labelCls }>
      <span className={ containerCls }>
        { labelValue }
      </span>
    </span>
  );
}

export default Label;
